// One build, two environments (plan §4.1). The page that served this build declares it in `window.__RADISH_ENV__`
// (public/__radish/env.js on the cloud host; the location node answers the same path with its location), so the
// bundle is identical in both places and never decides its environment at build time.
import { z } from 'zod';

const Environment = z.discriminatedUnion('profile', [
  z.object({ profile: z.literal('cloud'), apiBase: z.string() }),
  z.object({ profile: z.literal('location'), apiBase: z.string(), locationId: z.uuid(), nodeId: z.uuid() }),
]);

export type BackofficeEnvironment = z.infer<typeof Environment>;

declare global {
  interface Window {
    __RADISH_ENV__?: unknown;
  }
}

/** The served environment; an absent or malformed declaration is the cloud profile on this origin. */
export function readEnvironment(source: unknown = typeof window === 'undefined' ? undefined : window.__RADISH_ENV__): BackofficeEnvironment {
  const parsed = Environment.safeParse(source);
  return parsed.success ? parsed.data : { profile: 'cloud', apiBase: '' };
}
